import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import toast from 'react-hot-toast'
import { baseUrl } from '../../../../app.config'
// import { baseUrl } from '../../../../app.config'

export const getMyTrick = createAsyncThunk(
  'MyTrick/getMyTrick',
  async (params, { dispatch }) => {
    const headers = {}
    try {
      const response = await axios.post(baseUrl +'/userapi/mytrick', {...params,trickStatus:params?.trickStatus ?? 1,brokerId:params?.brokerId ?? 0},{ withCredentials:true, headers })
      return {
        trick_list: response?.data?.data?.trick_list || [],
        total: response?.data?.data?.total || 1,
        // noofPages: response?.data?.data?.noofPages,
        pageNumber: params?.pageNumber || 1,
        pageSize: params?.pageSize || 6,
      }
    } catch (e) {
      toast.error(e?.response?.data?.message)
      dispatch(setError(e?.response?.data?.message))
      dispatch(setLoader(false))
    }
  }
)

export const getMyTrickCalculation = createAsyncThunk(
  'MyTrick/getMyTrickCalculation',
  async (params, { dispatch }) => {
    const headers = {}
    try {
      const response = await axios.post(baseUrl +'/userapi/myTrickCalculation', {...params,trickStatus:params?.trickStatus ?? 1,brokerId:params?.brokerId ?? 0},{ withCredentials:true, headers })
      return {
        myTrick: response?.data?.data,
      }
    } catch (e) {
      toast.error(e?.response?.data?.message)
      dispatch(setError(e?.response?.data?.message))
      dispatch(setLoader(false))
    }
  }
)

export const MyTrick = createSlice({
  name: 'MyTrick',
  initialState: {
    myTrick:[],
    myTrickList:[],
    loader: true,
    error:'',
    pageType:'Live',
    pageNumber: 1,
    pageSize: 6,
    Search: '',
    total: 0,
    selected: null
  },
  reducers: {
    setSelect: (state, action) => {
      if (action.payload === null) {
        state.selected = null
      } else {
        state.selected = action.payload
      }
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setLoader: (state, action) => {
      state.loader = action.payload
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload
    },
    setPageType: (state, action) => {
      state.pageType = action.payload
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload.pageSize
    },
    setSearch: (state, action) => {
      state.params = { ...state.params, search: action.payload }
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getMyTrick.fulfilled, (state, action) => {
      //console.log('action', action)
      state.myTrickList = action?.payload?.trick_list
      state.pageNumber = action?.payload?.pageNumber
      state.pageSize = action?.payload?.pageSize
      state.total = action?.payload?.total
      state.loader = false
    }),
    builder.addCase(getMyTrickCalculation.fulfilled, (state, action) => {
      //console.log('action', action)
      state.myTrick = action?.payload?.myTrick
      state.loader = false
    })
   
  }
})

export const { setSelect,setError, setLoader, setPageNumber, setPageSize, setSearch, setPageType } =
  MyTrick.actions

export default MyTrick.reducer